import { Anchor, type MantineThemeOverride } from "@mantine/core";

import AnchorStyles from "./Anchor.module.css";

export const anchorOverrides: MantineThemeOverride["components"] = {
  Anchor: Anchor.extend({
    // Underlined by default, not just on hover — a contextual link
    // identified only by color, with no other cue until hovered, isn't
    // visually evident to someone who can't perceive the color difference
    // (WCAG 1.4.1). Callers with a legitimate non-contextual use (e.g. an
    // Anchor styled as a button/nav item) can still override per-instance.
    defaultProps: {
      underline: "always",
    },
    classNames: {
      root: AnchorStyles.root,
    },
  }),
};
